import { endpoints, request } from '!core/api';

export const fundsServices = {
  fundsInfo: ({ securityType, securityExchange }) =>
    request.get(
      endpoints.backoffice(
        `fundsInfo?securityType=${securityType}${securityExchange ? `&securityExchange=${securityExchange}` : ''}`,
      ),
    ),
  fundSubmit: ({
    simulationId,
    operation,
    clientId,
    cashAccount,
    securityExchange,
    symbol,
    isin,
    currency,
    side,
    qtyType,
    orderQty,
    timeInForce,
    expireTime,
    settlLocation,
    confirmSeq,
  }) =>
    request.post(endpoints.simo('fundSubmit'), {
      simulationId,
      operation,
      clientId,
      cashAccount,
      securityExchange,
      symbol,
      isin,
      currency,
      side,
      qtyType,
      orderQty,
      timeInForce,
      expireTime,
      settlLocation,
      field_1: null,
      field_2: null,
      field_3: null,
      field_4: null,
      field_5: null,
      confirmSeq,
    }),
};
